/* © CNES */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Image } from 'primereact/image';
import { useEffect, useState } from 'react';
import cookie from './cookie.png';
import './Cookies.scss';

/**
 * Display a dialog box to accept cookies.
 * @returns Cookies Element.
 */
export const Cookies = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('cookiesAccepted') === 'true') {
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);

  /**
   * Method allows cookiesAccepted to be added to browser's local storage
   */
  const setCookie = () => {
    localStorage.setItem('cookiesAccepted', JSON.stringify(true));
    setVisible(false);
  };

  return (
    <Dialog
      visible={visible}
      className="DialogCookie"
      onHide={() => {}}
      position="center"
    >
      <div className="cookieImage">
        <Image src={cookie} alt="cookie" />
      </div>
      <p className="titleCookie">Your privacy</p>
      <p className="messageCookie">
        By clicking "Necessary cookies only", you allow cookies to be stored on
        your device and disclose anonymous information in accordance with our
        <a
          href="https://geodes.cnes.fr/legal-mentions/#confidentialite"
          target="_blank"
          rel="noreferrer"
        >
          Cookie Policy
        </a>
        .
      </p>
      <div className="buttonCookie">
        <Button label="Necessary cookies only" onClick={setCookie} />
      </div>
    </Dialog>
  );
};
